import styled from 'styled-components';
import { Link } from 'react-router-dom';

const NavSubOption = styled.a`
  display: block;
  position: relative;
  opacity: ${({ selected }) => (selected ? 1 : 0.75)};
  padding: 0 21px;
  color: ${({ theme, selected }) => (selected ? theme.mainColor : theme.colors.font)};

  &:after {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    opacity: 0;
    width: 4px;
    content: '';
    background-color: ${({ theme }) => theme.secondaryColor};
  }

  &:hover {
    opacity: 1;
    color: ${({ theme }) => theme.colors.font};

    &:after {
      opacity: 1;
    }
  }
`;

export const NavSubOptionLink = NavSubOption.withComponent(Link);
